<template>
  <div class="event-wrap">
    <div class="btn-content">
      <el-button icon="el-icon-plus" type="primary" @click="showVisibleEvent"
        >新增告警探测规则</el-button
      >
    </div>
    <div class="table-content">
      <nk-table
        ref="nkTable"
        :showIndex="true"
        :data="tableData"
        noDataTitle="暂无告警探测规则"
        :columns="columns"
        :rowselect="true"
        @handleRowClick="handleRowClick"
      >
        <el-table-column
          slot="enable"
          label="是否启用"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.enable === 1">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          slot="operation"
          label="操作"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="editRow(scope.row, scope.$index)"
              >编辑</el-button
            >
            <el-button type="text" @click="delEvent(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </nk-table>
    </div>

    <div class="btn-content">
      <el-button icon="el-icon-plus" type="primary" @click="showVisibleMsg"
        >新增告警通知规则</el-button
      >
    </div>
    <div class="table-content">
      <nk-table
        ref="msgNkTable"
        :showIndex="true"
        :data="msgTableData"
        noDataTitle="暂无告警通知规则"
        :columns="columnsMsg"
        :rowselect="true"
      >
        <el-table-column
          slot="enable"
          label="是否启用"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.enable === 1">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          slot="operation"
          label="操作"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="editMsgRow(scope.row, scope.$index)"
              >编辑</el-button
            >
            <el-button type="text" @click="delMsg(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </nk-table>
    </div>

    <!-- 新增告警 -->
    <div>
      <el-dialog
        :title="eventInfo.id ? '修改告警探测规则' : '新增告警探测规则'"
        :visible.sync="visibleEvent"
        width="500px"
        :close-on-click-modal="false"
        :modal="false"
      >
        <el-form
          ref="form"
          :rules="rules"
          :model="eventInfo"
          label-width="140px"
        >
          <el-form-item label="名称" prop="name">
            <el-input v-model="eventInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="显示名称" prop="displayName">
            <el-input v-model="eventInfo.displayName"></el-input>
          </el-form-item>
          <el-form-item v-if="!eventInfo.id" label="告警项" prop="code">
            <el-select
              v-model="eventInfo.code"
              @change="eventChange"
              style="margin-right: 10px"
            >
              <el-option
                v-for="(item, index) in evenCode"
                :key="index"
                :value="item.id"
                :label="item.label"
              ></el-option>
            </el-select>
            <el-button type="text" @click="codeChange(eventInfo.code, true)"
              >同步名称</el-button
            >
          </el-form-item>
          <el-form-item label="告警类型" prop="type">
            <el-select v-model="eventInfo.type">
              <el-option
                v-for="(item, index) in eventTypes"
                :key="index"
                :value="item.id"
                :label="item.displayName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测量编码" prop="pointCode">
            <el-select v-model="eventInfo.params.pointCode">
              <el-option
                v-for="(item, index) in codeData"
                :key="index"
                :value="item.code"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测量编号" prop="pointNumber">
            <el-input v-model="eventInfo.params.pointNumber"></el-input>
          </el-form-item>
          <template v-if="formType == 1">
            <el-form-item label="阀值" prop="threshold">
              <el-input v-model="eventInfo.params.threshold"></el-input>
            </el-form-item>
          </template>
          <template v-if="formType == 2">
            <el-form-item label="阀值" prop="threshold">
              <el-input v-model="eventInfo.params.threshold"></el-input>
            </el-form-item>
            <el-form-item label="持续时间" prop="duration">
              <el-input v-model="eventInfo.params.duration"></el-input>
            </el-form-item>
            <el-form-item label="返回值" prop="recover">
              <el-input v-model="eventInfo.params.recover"></el-input>
            </el-form-item>
          </template>
          <template v-if="formType == 3 || formType == 4">
            <el-form-item label="持续时间" prop="duration">
              <el-input v-model="eventInfo.params.duration"></el-input>
            </el-form-item>
          </template>
          <template v-if="formType == 5">
            <el-form-item label="持续时间" prop="duration">
              <el-input v-model="eventInfo.params.duration"></el-input>
            </el-form-item>
            <el-form-item label="触发状态" prop="triggers">
              <el-input v-model="eventInfo.params.triggers"></el-input>
            </el-form-item>
            <el-form-item label="返回状态" prop="recovers">
              <el-input v-model="eventInfo.params.recovers"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="引用的其它规则" v-show="eventInfo.code != ''">
            <el-switch
              v-model="eventInfo.reference"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-form-item>
          <el-form-item
            label="引用规则"
            prop="referenceTo"
            v-show="eventInfo.reference"
          >
            <label>{{
              eventInfo.referenceToItem
                ? eventInfo.referenceToItem.displayName
                : ""
            }}</label>
            <el-button type="text" @click="bindShowReferenceTo"
              >选择引用规则</el-button
            >
          </el-form-item>
          <el-form-item label="是否由设备探测告警" prop="enable">
            <el-switch
              v-model="eventInfo.detectingByPhysicalDevice"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-form-item>
          <el-form-item label="是否启用" prop="enable">
            <el-switch
              v-model="eventInfo.enable"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveEvent">确 定</el-button>
          <el-button @click="visibleEvent = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 新增告警 -->
    <div>
      <el-dialog
        :title="msgInfo.id ? '修改告警通知规则' : '新增告警通知规则'"
        :visible.sync="visibleMsg"
        width="500px"
        :close-on-click-modal="false"
        :modal="false"
      >
        <el-form ref="form" :model="msgInfo" label-width="140px">
          <el-form-item label="通知对象" prop="targetUserId">
            <el-select v-model="msgInfo.targetUserId">
              <el-option
                v-for="(item, index) in userData"
                :key="index"
                :value="item.id"
                :label="item.nickname"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通知方法" prop="notifyingBy">
            <el-select v-model="msgInfo.notifyingBy">
              <el-option
                v-for="(item, index) in notifyingByData"
                :key="index"
                :value="item.id"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="告警等级" prop="level">
            <el-select v-model="msgInfo.level">
              <el-option
                v-for="(item, index) in levelData"
                :key="index"
                :value="item.id"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否启用" prop="enable">
            <el-switch
              v-model="msgInfo.enable"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveMsgInfo">确 定</el-button>
          <el-button @click="visibleMsg = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>

    <div>
      <el-dialog
        title="选择引用规则"
        :visible.sync="visibleReferenceTo"
        width="800px"
        :close-on-click-modal="false"
        :modal="false"
      >
        <div style="display: flex; overflow: hidden">
          <div style="flex: 0 0 240px; overflow: hidden">
            <div style="padding: 6px; background: #00388c; color: #fff">
              对象列表：
              <el-select
                style="width: 140px"
                size="mini"
                v-model="objId"
                @change="objChange"
              >
                <el-option
                  v-for="(item, index) in objData"
                  :key="index"
                  :value="item.id"
                  :label="item.displayName"
                ></el-option>
              </el-select>
            </div>
            <div>
              <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText"
              ></el-input>
            </div>
            <div style="width: 100%; height: 200px; overflow: auto">
              <el-tree
                ref="pointTree"
                :data="treeData"
                node-key="id"
                :props="defaultProps"
                :filter-node-method="filterNode"
                @node-click="nodeClick"
              ></el-tree>
            </div>
          </div>
          <div style="flex: 1">
            <nk-table
              :columns="referenceToColumns"
              :data="referenceToTable"
              :rowselect="true"
              @handleRowClick="referenceToHandleRowClick"
            ></nk-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="referenceToOk">确 定</el-button>
          <el-button @click="visibleReferenceTo = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import NkTable from "@/components/common/NkTable";
import api from "@common/api/index.js";
import { EVEN } from "@/config/data";
import tree from "@/utils/tree";
export default {
  components: { NkTable },
  data() {
    return {
      columns: [
        { prop: "name", label: "名称", show: true },
        { prop: "displayName", label: "显示名称", show: true },
        { prop: "codeName", label: "告警项", show: true },
        { prop: "typeName", label: "类型", show: true },
        { prop: "enable", slot: "enable", label: "启用", show: true },
        { prop: "operation", slot: "operation", label: "操作", show: true },
      ],
      evenCode: [],
      eventTypes: [],
      formType: 0,
      tableData: [],
      visibleEvent: false,
      eventInfo: {
        params: {},
      },
      editIndex: -1,
      rules: {},
      selectedEventItem: null,
      msgTableData: [],
      columnsMsg: [
        { prop: "targetUserNickname", label: "通知对象", show: true },
        { prop: "notifyingByName", label: "通知方法", show: true },
        { prop: "levelName", label: "告警等级", show: true },
        { prop: "enable", slot: "enable", label: "启用", show: true },
        { prop: "operation", slot: "operation", label: "操作", show: true },
      ],
      visibleMsg: false,
      msgInfo: {},
      userData: [],
      notifyingByData: [
        { id: 1, label: "站内短信" },
        { id: 2, label: "手机短信" },
        { id: 3, label: "邮箱" },
      ],
      levelData: [
        { id: 1, label: "一级" },
        { id: 2, label: "二级" },
        { id: 3, label: "三级" },
        { id: 4, label: "四级" },
        { id: 5, label: "五级" },
        { id: 6, label: "六级" },
      ],
      editMsgIndex: -1,
      codeData: [],

      visibleReferenceTo: false,
      objData: [],
      objId: "",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "measureName",
      },
      selectedItem: null,
      filterText: "",
      referenceToColumns: [
        { prop: "name", label: "名称", show: true },
        { prop: "displayName", label: "显示名称", show: true },
        { prop: "codeName", label: "告警项", show: true },
        { prop: "typeName", label: "类型", show: true },
        { prop: "enable", slot: "enable", label: "启用", show: true },
      ],
      referenceToTable: [],
      selectedReferenceTo: null,
    };
  },
  props: {
    measureId: {
      type: String,
      default: "",
    },
    templateId: {
      type: String,
      default: "",
    },
  },
  watch: {
    measureId(val) {
      if (val && val.length > 0) {
        this.getData(val);
      }
    },
    filterText(val) {
      this.$refs.pointTree.filter(val);
    },
  },
  created() {
    this.getData(this.measureId);
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.measureName.indexOf(value) !== -1;
    },
    async getEventCodeRestrictionOfMeasureTemplate(templateId) {
      let vm = this;
      await api.measure
        .getEventCodeRestrictionOfMeasureTemplate(templateId)
        .then((res) => {
          if (res) {
            let evenCode = [];
            for (let i = 0; i < res.data.length; i++) {
              let item = EVEN.find((obj) => obj.id == res.data[i].code);
              // res.data[i].label = item ? item.label : res.data[i].code;
              // res.data[i].type = item ? item.type : 0;
              if (item) {
                item = Object.assign(item, res.data[i]);
                evenCode.push(item);
              }
            }
            vm.evenCode = evenCode;
          }
        });
    },
    getData(id) {
      let vm = this;
      vm.getEventTypes();
      api.event.getEventDetectRegulations(id).then((res) => {
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          const item = EVEN.find((obj) => obj.id == res.data[index].code);
          res.data[index].codeName = item ? item.label : res.data[index].code;

          const typeItem = vm.eventTypes.find(
            (obj) => obj.id == res.data[index].type
          );
          res.data[index].typeName = typeItem
            ? typeItem.displayName
            : res.data[index].type;
        }
        vm.tableData = res.data;
        vm.getEventCodeRestrictionOfMeasureTemplate(vm.templateId);
        if (vm.tableData.length > 0) {
          this.$nextTick(() => {
            vm.$refs.nkTable.setCurrentRow(vm.tableData[0]);
          });
          vm.getEventNotifyRegulations(vm.tableData[0]);
        } else {
          this.msgTableData = [];
        }
      });
    },
    async getEventTypes() {
      await api.event.getEventTypes().then((res) => {
        this.eventTypes = res.data;
      });
    },
    showVisibleEvent() {
      this.eventInfo = {
        name: "",
        displayName: "",
        measureId: this.measureId,
        code: "",
        type: "",
        params: {
          pointCode: 0,
          pointNumber: 0,
        },
        reference: false,
        referenceTo: 0,
        detectingByPhysicalDevice: false,
        enable: true,
      };
      // this.getEventTypes();
      this.visibleEvent = true;
    },
    eventChange(id) {
      let vm = this;
      let codeData = [];
      const item = vm.evenCode.find((obj) => obj.id == id);
      for (let index = 0; index < item.code.length; index++) {
        const element = item.code[index];
        const code = window.baseConfig.collectData.find(
          (c) => c.code == element
        );
        if (code) {
          codeData.push(code);
        }
      }
      vm.codeData = codeData;
      if (codeData.length > 0 && vm.eventInfo.params.pointCode == 0) {
        vm.eventInfo.params.pointCode = codeData[0].code;
      }
      vm.codeChange(id);
      vm.formType = item.type;
    },
    saveEvent() {
      let vm = this;
      if (vm.eventInfo.reference === false) {
        vm.eventInfo.referenceTo = 0;
      }
      if (vm.eventInfo.id) {
        vm.saveEventEdit();
      } else {
        api.event
          .addEventDetectRegulation(
            vm.eventInfo.name,
            vm.eventInfo.displayName,
            vm.eventInfo.measureId,
            vm.eventInfo.code,
            vm.eventInfo.type,
            2,
            JSON.stringify(vm.eventInfo.params),
            vm.eventInfo.referenceTo,
            vm.eventInfo.detectingByPhysicalDevice ? 1 : 0,
            vm.eventInfo.enable ? 1 : 0
          )
          .then((res) => {
            if (res.success) {
              vm.$message.success("添加成功！");
              vm.eventInfo.id = res.data.id;
              vm.eventInfo.enable = vm.eventInfo.enable ? 1 : 0;
              const item = EVEN.find((obj) => obj.id == vm.eventInfo.code);
              vm.eventInfo.codeName = item ? item.label : vm.eventInfo.code;

              const typeItem = vm.eventTypes.find(
                (obj) => obj.id == vm.eventInfo.type
              );
              vm.eventInfo.typeName = typeItem
                ? typeItem.displayName
                : vm.eventInfo.type;
              vm.tableData.push(vm.eventInfo);
              vm.$refs.nkTable.setCurrentRow(vm.eventInfo);
              this.getEventNotifyRegulations(vm.eventInfo);
              vm.visibleEvent = false;
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
      }
    },
    delEvent(item, index) {
      let vm = this;
      this.$confirm("此操作将永久删除该告警探测规则, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.event.deleteEventDetectRegulation(item.id).then((res) => {
            if (res.success) {
              vm.$message("删除成功！");
              vm.tableData.splice(index, 1);
              if (vm.tableData.length > 0) {
                vm.msgTableData = [];
              } else {
                vm.getEventNotifyRegulations(vm.tableData[0]);
              }
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
        })
        .catch(() => {});
    },
    editRow(item, index) {
      let vm = this;
      let eventInfo = JSON.parse(JSON.stringify(item));
      if (eventInfo.params.value) {
        eventInfo.params = JSON.parse(eventInfo.params.value);
      } else {
        eventInfo.params =
          typeof eventInfo.params === "string"
            ? JSON.parse(eventInfo.params)
            : eventInfo.params;
      }

      eventInfo.reference = false;
      eventInfo.referenceToItem = { displayName: "" };
      eventInfo.enable = eventInfo.enable == 1 ? true : false;
      const obj = vm.evenCode.find((obj) => obj.id == item.code);
      vm.formType = obj.type;
      vm.editIndex = index;
      vm.eventChange(item.code);
      if (eventInfo.referenceTo > 0) {
        eventInfo.reference = true;
        api.event
          .getEventDetectRegulations2(JSON.stringify([eventInfo.referenceTo]))
          .then((res) => {
            if (res.data.length > 0) {
              eventInfo.referenceToItem = res.data[0];
            }
            vm.eventInfo = eventInfo;
            vm.visibleEvent = true;
          });
      } else {
        vm.eventInfo = eventInfo;
        vm.visibleEvent = true;
      }
      console.log(vm.eventInfo);
    },
    saveEventEdit() {
      let vm = this;
      api.event
        .modifyEventDetectRegulation(
          vm.eventInfo.id,
          vm.eventInfo.name,
          vm.eventInfo.displayName,
          vm.eventInfo.type,
          JSON.stringify(vm.eventInfo.params),
          vm.eventInfo.referenceTo,
          vm.eventInfo.enable ? 1 : 0
        )
        .then((res) => {
          if (res.success) {
            vm.$message("修改成功！");
            // vm.eventInfo.id = res.data.id;
            let tableData = JSON.parse(JSON.stringify(vm.tableData));
            vm.tableData = [];
            const item = EVEN.find((obj) => obj.id == vm.eventInfo.code);
            vm.eventInfo.codeName = item ? item.label : vm.eventInfo.code;
            const typeItem = vm.eventTypes.find(
              (obj) => obj.id == vm.eventInfo.type
            );
            vm.eventInfo.typeName = typeItem
              ? typeItem.displayName
              : vm.eventInfo.type;
            tableData[vm.editIndex] = vm.eventInfo;
            tableData[vm.editIndex].enable =
              vm.eventInfo.enable == true ? 1 : 0;
            vm.tableData = tableData;
            vm.$refs.nkTable.setCurrentRow(vm.eventInfo);
            this.getEventNotifyRegulations(vm.eventInfo);
            vm.visibleEvent = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    handleRowClick(item) {
      this.getEventNotifyRegulations(item);
    },
    getEventNotifyRegulations(item, id = null) {
      let vm = this;
      vm.selectedEventItem = item;
      api.event.getEventNotifyRegulations(item.id).then((res) => {
        if (res.success) {
          for (let index = 0; index < res.data.length; index++) {
            const notifyingByitem = vm.notifyingByData.find(
              (obj) => obj.id == res.data[index].notifyingBy
            );
            res.data[index].notifyingByName = notifyingByitem
              ? notifyingByitem.label
              : res.data[index].notifyingBy;

            const levelitem = vm.levelData.find(
              (obj) => obj.id == res.data[index].level
            );
            res.data[index].levelName = levelitem
              ? levelitem.label
              : res.data[index].level;
          }
          vm.msgTableData = res.data;
          if (vm.msgTableData.length > 0) {
            if (id) {
              const item = vm.msgTableData.find((c) => c.id == id);
              ///////////////////
              vm.$refs.msgNkTable.setCurrentRow(item);
            } else {
              vm.$refs.msgNkTable.setCurrentRow(vm.msgTableData[0]);
            }
          }
        }
      });
    },
    showVisibleMsg() {
      let vm = this;
      if (vm.selectedEventItem) {
        vm.getUsersInfos();
        vm.msgInfo = {
          detectRegulationId: vm.selectedEventItem.id,
          targetUserId: "",
          notifyingBy: "",
          level: "",
          enable: true,
        };
        vm.visibleMsg = true;
      }
    },
    async getUsersInfos() {
      let vm = this;
      await api.user
        .getUsersInfos2(
          vm.$store.state.user.info.companyId,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        )
        .then((res) => {
          vm.userData = res.data;
        });
    },
    saveMsgInfo() {
      let vm = this;
      if (!vm.msgInfo.id) {
        api.event
          .addEventNotifyRegulation(
            vm.msgInfo.detectRegulationId,
            vm.msgInfo.targetUserId,
            vm.msgInfo.notifyingBy,
            vm.msgInfo.level,
            vm.msgInfo.enable ? 1 : 0
          )
          .then((res) => {
            if (res.success) {
              vm.$message.success("添加成功！");
              // vm.msgInfo.id = res.data.id;
              // vm.msgTableData.push(vm.msgInfo);
              vm.getEventNotifyRegulations(vm.selectedEventItem);
              vm.visibleMsg = false;
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
      } else {
        api.event
          .modifyEventNotifyRegulation(
            vm.msgInfo.id,
            vm.msgInfo.targetUserId,
            vm.msgInfo.notifyingBy,
            vm.msgInfo.level,
            vm.msgInfo.enable ? 1 : 0
          )
          .then((res) => {
            if (res.success) {
              vm.$message("修改成功！");
              // vm.msgTableData = [];
              // let data = JSON.parse(JSON.stringify(vm.msgTableData));
              // const user = vm.userData.find(
              //   (obj) => obj.id == vm.msgInfo.targetUserId
              // );
              // vm.msgInfo.targetUserNickname = user
              //   ? user.nickname
              //   : vm.msgInfo.targetUserId;
              // data[vm.editMsgIndex] = vm.msgInfo;
              // data[vm.editMsgIndex].enable = vm.msgInfo.enable ? 1 : 0;
              // vm.msgTableData = data;

              vm.getEventNotifyRegulations(vm.selectedEventItem, vm.msgInfo.id);
              vm.visibleMsg = false;
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
      }
    },
    editMsgRow(item, index) {
      let vm = this;
      vm.editMsgIndex = index;
      vm.getUsersInfos();
      vm.msgInfo = JSON.parse(JSON.stringify(item));
      vm.msgInfo.enable = vm.msgInfo.enable == 1 ? true : false;
      vm.visibleMsg = true;
    },
    delMsg(item, index) {
      let vm = this;
      this.$confirm("此操作将永久删除该告警通知规则, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.event.deleteEventNotifyRegulation(item.id).then((res) => {
            if (res.success) {
              vm.$message("删除成功！");
              vm.msgTableData.splice(index, 1);
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
        })
        .catch(() => {});
    },
    bindShowReferenceTo() {
      let vm = this;
      vm.getCompanyViewTreesInfo();
      vm.visibleReferenceTo = true;
    },
    objChange(val) {
      this.getViewTreeNodes(val);
    },
    async getCompanyViewTreesInfo() {
      let vm = this;
      await api.view
        .getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res) {
            vm.objData = res.data;
            if (res.data.length > 0) {
              vm.objId = res.data[0].id;
              vm.getViewTreeNodes(vm.objId);
            }
          }
        });
    },
    async getViewTreeNodes(id) {
      await api.view.getViewTreeNodes(id).then((res) => {
        let data = tree.creatTreeJson(res.data, 0);
        this.treeData = data;
      });
    },
    nodeClick(data) {
      let vm = this;
      api.event.getEventDetectRegulations(data.measureId).then((res) => {
        let arr = [];
        for (let index = 0; index < res.data.length; index++) {
          if (res.data[index].code == vm.eventInfo.code) {
            const element = res.data[index];
            const item = EVEN.find((obj) => obj.id == res.data[index].code);
            res.data[index].codeName = item ? item.label : res.data[index].code;

            const typeItem = vm.eventTypes.find(
              (obj) => obj.id == res.data[index].type
            );
            res.data[index].typeName = typeItem
              ? typeItem.displayName
              : res.data[index].type;
            arr.push(res.data[index]);
          }
        }
        vm.referenceToTable = arr;
      });
    },
    referenceToHandleRowClick(data) {
      let vm = this;
      vm.selectedReferenceTo = data;
    },
    referenceToOk() {
      let vm = this;
      if (vm.selectedReferenceTo) {
        vm.eventInfo.referenceTo = vm.selectedReferenceTo.id;
        vm.eventInfo.referenceToItem = JSON.parse(
          JSON.stringify(vm.selectedReferenceTo)
        );
      }
      vm.visibleReferenceTo = false;
    },
    codeChange(data, issync = false) {
      let vm = this;
      let item = vm.evenCode.find((c) => c.id == data);
      if (item) {
        if (issync) {
          vm.eventInfo.name = item.name;
          vm.eventInfo.displayName = item.label;
        } else {
          if (vm.eventInfo.name && vm.eventInfo.name.length == 0) {
            vm.eventInfo.name = item.enName;
          }
          if (
            vm.eventInfo.displayName &&
            vm.eventInfo.displayName.length == 0
          ) {
            vm.eventInfo.displayName = item.label;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.event-wrap {
  width: 100%;
  padding: 0px 10px;
  box-sizing: border-box;
}
.btn-content {
  text-align: left;
  padding-bottom: 10px;
}
.table-content {
  height: 300px;
  padding-bottom: 10px;
}
</style>
<style lang="scss">
.event-wrap {
  text-align: left;
  .el-dialog__header {
    text-align: left;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__body {
    padding: 20px;
  }
}
</style>